import { Box, MenuItem, Select, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import useClientContext from "../../../contexts/useClientContext";
import { permissionsSelector } from "../../../store/state/user/selectors";
import SwipeableBottomDrawer from "../../common/SwipeableBottomDrawer";
import { shouldShowPortalSwitcher } from "../portalSwitcherHelper";
import PortalList from "../PortalList";
import PortalLogoMark from "../PortalLogoMark";
import SwipeableBottomDrawerHeader from "./SwipeableBottomDrawerHeader";

interface Props {
  onNavigate: () => void;
}

const PortalSwitcherRow = ({ onNavigate }: Props) => {
  const { clientCode, clientTitle, portalSettings } = useClientContext();
  const permissions = useSelector(permissionsSelector);
  const [open, setOpen] = useState(false);

  const canSwitch = shouldShowPortalSwitcher(permissions);

  const handleNavigate = () => {
    setOpen(false);
    onNavigate();
  };

  return (
    <>
      <Select
        fullWidth
        value={clientCode}
        open={false}
        readOnly={!canSwitch}
        onOpen={() => setOpen(true)}
        renderValue={() => (
          <Stack direction="row" sx={{ gap: 1 }}>
            <PortalLogoMark logoUrl={portalSettings?.logoMarkUrl} title={clientTitle} />
            <Typography variant="subtitle2" noWrap>
              {clientTitle}
            </Typography>
          </Stack>
        )}
      >
        <MenuItem value={clientCode}>{clientTitle}</MenuItem>
      </Select>
      <SwipeableBottomDrawer open={open} onClose={() => setOpen(false)}>
        <SwipeableBottomDrawerHeader title="Portals" onClose={() => setOpen(false)} />
        <Box sx={{ px: 2, py: 3 }}>
          <PortalList onNavigate={handleNavigate} />
        </Box>
      </SwipeableBottomDrawer>
    </>
  );
};

export default PortalSwitcherRow;
